import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const ChevronUp = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M12.0001 10.9913l-3.8042 3.8045c-.2114.2112-.4766.3168-.7958.3168-.3192 0-.5844-.1056-.7957-.3168-.2112-.2113-.3168-.4766-.3168-.7957 0-.3192.1056-.5845.3167-.7958l4.594-4.594c.228-.2278.4953-.3418.8018-.3418.3065 0 .5737.114.8017.3418l4.594 4.594c.2112.2113.3168.4766.3168.7958 0 .3191-.1056.5844-.3168.7957-.2113.2112-.4765.3168-.7957.3168s-.5844-.1056-.7958-.3168l-3.8042-3.8045z"
    }),
    filledrtl: /*#__PURE__*/React.createElement("path", {
      d: "M12.0001 10.9913l-3.8042 3.8045c-.2114.2112-.4766.3168-.7958.3168-.3192 0-.5844-.1056-.7957-.3168-.2112-.2113-.3168-.4766-.3168-.7957 0-.3192.1056-.5845.3167-.7958l4.594-4.594c.228-.2278.4953-.3418.8018-.3418.3065 0 .5737.114.8017.3418l4.594 4.594c.2112.2113.3168.4766.3168.7958 0 .3191-.1056.5844-.3168.7957-.2113.2112-.4765.3168-.7957.3168s-.5844-.1056-.7958-.3168l-3.8042-3.8045z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M12.0001 10.9913l-3.8042 3.8045c-.2114.2112-.4766.3168-.7958.3168-.3192 0-.5844-.1056-.7957-.3168-.2112-.2113-.3168-.4766-.3168-.7957 0-.3192.1056-.5845.3167-.7958l4.594-4.594c.228-.2278.4953-.3418.8018-.3418.3065 0 .5737.114.8017.3418l4.594 4.594c.2112.2113.3168.4766.3168.7958 0 .3191-.1056.5844-.3168.7957-.2113.2112-.4765.3168-.7957.3168s-.5844-.1056-.7958-.3168l-3.8042-3.8045z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M12.0001 10.9913l-3.8042 3.8045c-.2114.2112-.4766.3168-.7958.3168-.3192 0-.5844-.1056-.7957-.3168-.2112-.2113-.3168-.4766-.3168-.7957 0-.3192.1056-.5845.3167-.7958l4.594-4.594c.228-.2278.4953-.3418.8018-.3418.3065 0 .5737.114.8017.3418l4.594 4.594c.2112.2113.3168.4766.3168.7958 0 .3191-.1056.5844-.3168.7957-.2113.2112-.4765.3168-.7957.3168s-.5844-.1056-.7958-.3168l-3.8042-3.8045z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
ChevronUp.displayName = "ChevronUpIcon";

export { ChevronUp, ChevronUp as default };
